// extracted by mini-css-extract-plugin
module.exports = {"container":"developingFeedback_container__38sbQ","message":"developingFeedback_message__1yREr"};